import { useEffect, useState } from "react";
import api from "@/lib/api";
import { fmtInt, fmtDateTime } from "@/lib/format";
import { Badge } from "@/components/StatusBadge";
import { Input } from "@/components/ui/input";
import ExportButton from "@/components/ExportButton";
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from "@/components/ui/select";

const TYPE_LABELS = {
  initial: "İlk Stok", production_in: "Üretim Girişi",
  ready_purchase_in: "Hazır Alım", return_in: "İade Girişi",
  count_excess: "Sayım Fazlası", manual_increase: "Manuel+",
  sales_out: "Satış Çıkışı", sample: "Numune", demo: "Demo",
  gift: "Hediye", count_deficit: "Sayım Eksiği", fire: "Fire",
  manual_decrease: "Manuel-",
};

export default function StockMovements() {
  const [items, setItems] = useState([]);
  const [type, setType] = useState("all");
  const [q, setQ] = useState("");

  useEffect(() => {
    const params = {};
    if (type !== "all") params.movement_type = type;
    api.get("/stock/movements", { params }).then((r) => setItems(r.data));
  }, [type]);

  const filtered = q
    ? items.filter((m) => (m.product_name || "").toLowerCase().includes(q.toLowerCase()) ||
                          (m.product_code || "").toLowerCase().includes(q.toLowerCase()))
    : items;

  return (
    <div className="space-y-4">
      <div className="flex justify-end">
        <ExportButton type="stock-movements" label="Stok Hareketlerini İndir" />
      </div>
      <div className="azd-card p-4 lg:p-5">
        <div className="grid lg:grid-cols-3 gap-3">
          <div>
            <label className="block text-xs font-semibold text-[#111827] mb-1.5">Ara</label>
            <Input data-testid="movements-search" value={q} onChange={(e) => setQ(e.target.value)}
                   placeholder="Ürün adı veya kodu..." />
          </div>
          <div>
            <label className="block text-xs font-semibold text-[#111827] mb-1.5">Hareket Tipi</label>
            <Select value={type} onValueChange={setType}>
              <SelectTrigger data-testid="movements-type-filter"><SelectValue /></SelectTrigger>
              <SelectContent>
                <SelectItem value="all">Tümü</SelectItem>
                {Object.entries(TYPE_LABELS).map(([k, v]) => (
                  <SelectItem key={k} value={k}>{v}</SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>
        </div>
      </div>

      <div className="azd-card overflow-hidden">
        <div className="overflow-x-auto azd-scrollbar">
          <table className="w-full text-sm">
            <thead className="bg-[#F6F8FB] text-[11px] uppercase tracking-wider text-[#6B7280]">
              <tr>
                <th className="text-left px-4 py-3 font-semibold">Tarih</th>
                <th className="text-left px-4 py-3 font-semibold">Ürün</th>
                <th className="text-left px-4 py-3 font-semibold">Hareket</th>
                <th className="text-right px-4 py-3 font-semibold">Miktar</th>
                <th className="text-right px-4 py-3 font-semibold">Önce</th>
                <th className="text-right px-4 py-3 font-semibold">Sonra</th>
                <th className="text-left px-4 py-3 font-semibold">Belge</th>
                <th className="text-left px-4 py-3 font-semibold">Açıklama</th>
              </tr>
            </thead>
            <tbody>
              {filtered.length === 0 ? (
                <tr><td colSpan={8} className="p-8 text-center text-[#6B7280]">Hareket bulunamadı</td></tr>
              ) : filtered.map((m) => (
                <tr key={m.id} data-testid={`movement-row-${m.id}`}
                    className="border-t border-[#E5E7EB] hover:bg-[#F6F8FB]/50">
                  <td className="px-4 py-3 text-xs text-[#6B7280]">{fmtDateTime(m.created_at)}</td>
                  <td className="px-4 py-3">
                    <div className="font-semibold text-[#111827]">{m.product_name}</div>
                    <div className="text-xs text-[#6B7280] font-mono">{m.product_code}</div>
                  </td>
                  <td className="px-4 py-3">
                    <Badge variant={m.direction === "in" ? "success" : "error"}>
                      {TYPE_LABELS[m.movement_type] || m.movement_type}
                    </Badge>
                  </td>
                  <td className={`px-4 py-3 text-right font-bold ${
                    m.direction === "in" ? "text-[#16A34A]" : "text-[#DC2626]"}`}>
                    {m.direction === "in" ? "+" : "-"}{fmtInt(m.quantity)} {m.unit}
                  </td>
                  <td className="px-4 py-3 text-right text-[#6B7280] text-xs">{fmtInt(m.previous_stock)}</td>
                  <td className="px-4 py-3 text-right font-semibold text-[#08285A]">{fmtInt(m.new_stock)}</td>
                  <td className="px-4 py-3 text-xs text-[#6B7280] font-mono">{m.document_no || "-"}</td>
                  <td className="px-4 py-3 text-xs text-[#6B7280]">{m.description || "-"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
